module.exports = __webpack_public_path__ + "static/media/thermae.fa47db8d.svg";